import CityPageSEO from "@/hooks/usePageSEO";
import LawrencevilleHeroSection from "./components/HeroSection";
import LawrencevilleStickyNav from "./components/StickyNav";
import LawrencevilleProcessingTimeSection from "./components/ProcessingTimeSection";
import LawrencevilleServicesSection from "./components/ServicesSection";
import LawrencevilleHowItWorksSection from "./components/HowItWorksSection";
import LawrencevilleLocalAreaSection from "./components/LocalAreaSection";
import LawrencevilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LawrencevilleComparisonSection from "./components/ComparisonSection";
import LawrencevilleMistakesSection from "./components/MistakesSection";
import LawrencevilleTestimonialsSection from "./components/TestimonialsSection";
import LawrencevilleFAQSection, { faqs } from "./components/FAQSection";
import LawrencevilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LawrencevilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function LawrencevillePage() {
  return (
    <main>
      <CityPageSEO config={{
        cityName: "Lawrenceville",
        route: "/cities/lawrenceville",
        description: "Emergency and expedited passport services in Lawrenceville, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Gwinnett County and northeast metro Atlanta travelers. Get your emergency passport fast!",
        geoPlacename: "Lawrenceville, Georgia",
        geoPosition: "33.9562;-83.9880",
        keywords: "expedited passport, emergency passport, Lawrenceville passport, same day passport Lawrenceville, fast passport Georgia, Gwinnett County passport",
        faqs,
      }} />
      <LawrencevilleHeroSection />
      <LawrencevilleStickyNav />
      <LawrencevilleProcessingTimeSection />
      <LawrencevilleLocalAreaSection />
      <LawrencevilleServicesSection />
      <LawrencevilleHowItWorksSection />
      <LawrencevilleAcceptanceFacilitiesSection />
      <LawrencevilleComparisonSection />
      <LawrencevilleMistakesSection />
      <LawrencevilleTestimonialsSection />
      <LawrencevilleFAQSection />
      <LawrencevilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/lawrenceville" state="GA" />
      <LawrencevilleFinalCTA />
    </main>
  );
}